import { createStore, applyMiddleware } from "redux";
import rootReducer from "../reducers/index";
import createSagaMiddleware from "redux-saga";
import rootSaga from "../saga";
import { persistReducer } from 'redux-persist';
import storageSession from 'redux-persist/lib/storage/session';
import { CookieStorage } from 'redux-persist-cookie-storage';
import { OurCookieStorage } from "./OurCookieStorage";
import Cookies from 'cookies-js';
import { getDomain } from "../helpers/Tools";
import * as trueInitialState from "./trueInitialState";
import * as tools from "../helpers/Tools";

//const persistConfig = {
//    key: 'root',
//    keyPrefix: '',
//    storage: storageSession
//};

//const persistSSOConfig = {
//    key: 'root',
//    keyPrefix: '',
//    whitelist: ["sso"],
//    storage: new CookieStorage(Cookies)
//};

const sDomain = getDomain();
console.log("Domain is: " + sDomain);


const configureStore = (serverData) => {
    if (window.serverData.data.startupDebug) {
        debugger; // <- do NOT comment out, read the code please
    }
    //debugger;
    const persistOurConfig = {
        key: 'root',
        keyPrefix: '',
        storage: new OurCookieStorage(Cookies, {
            setCookieOptions: { domain: sDomain && sDomain === "localhost" ? null : sDomain, path: "/" },
            persistSSO: serverData ? serverData.persistSSO : null,
            persistSession: serverData ? serverData.persistSession : null,
            persistHeader: serverData ? serverData.persistHeader : null,
            persistDashboard: serverData ? serverData.persistDashboard : null,
            persistHealthPlan: serverData ? serverData.persistHealthPlan : null,
            persistPharmacy: serverData ? serverData.persistPharmacy : null,
            persistHealthSource: serverData ? serverData.persistHealthSource : null,
            persistDomain: serverData ? serverData.persistDomain : null,
            keyPrefix: serverData.environment + "-"
        })
    };

    let oState = trueInitialState.trueInitialState;

    //Immediately restoring state (from sessionStorage and/or cookies)
    //debugger;
    let oCurrState = window.serverData.data.storageControllerV2 ? tools.getSessionItem("root") : window.sessionStorage.getItem("root"); //    ;
    if (oCurrState) {
        oCurrState = JSON.parse(oCurrState);
    }
    let oCookieDomain = Cookies.get(serverData.environment + "-root-Domain");

    if (oCookieDomain && !window.serverData.data.storageControllerV2) {
        if (window.serverData.data.startupDebug) {
            debugger; // <- do NOT comment out, read the code please
        }
        var dBackDate = new Date();
        dBackDate.setDate(dBackDate.getDate() - 3);
        var oDomainFromCookie = JSON.parse(oCookieDomain);
        var oDomainFromSession = oCurrState ? JSON.parse(oCurrState.domain) : { lr: dBackDate };
        if (oDomainFromCookie.domain.lr > oDomainFromSession.lr) {
            oState = Object.assign(oState, oDomainFromCookie); // .domain = JSON.parse(oCurrState.domain);
        }
        else {
            oCookieDomain = null;
        }
    }
    else {
        oCookieDomain = null;
    }
    if (oCurrState) {
        try { oState.common = JSON.parse(oCurrState.common); } catch { }

        try { oState.dashboard = JSON.parse(oCurrState.dashboard); } catch { }
        try {
            if (!oCookieDomain) {
                oState.domain = JSON.parse(oCurrState.domain);
            }
        } catch { }
        if (oState.domain && oState.domain.ru) {
            //debugger;
            window.redirectURL = oState.domain.ru;
        };

        try { oState.header = JSON.parse(oCurrState.header); } catch { }
        try { oState.memberships = JSON.parse(oCurrState.memberships); } catch { }
        try { oState.sso = JSON.parse(oCurrState.sso); } catch { }
        try { oState.inHome = JSON.parse(oCurrState.inHome); } catch { }

        try {
            if (oCurrState.localCache) {
                var oCache = JSON.parse(oCurrState.localCache);
                if (typeof oCache !== "undefined") {
                    oState.localCache = oCache;
                }
            }
        } catch { }
    }
    let sCorrelationID = Cookies.get("bsw-CorrelationId");

    //debugger;
    if (sCorrelationID && oState && oState.domain) {
        oState.domain.c = sCorrelationID;
    }


    if (serverData) {
        oState.session.serverData = serverData;
    }
    //debugger;
    if (oState.domain && oState.domain.t) {
        oState.domain.li = true;
    }

    if (Object.keys(oState).length > 40) {
        //debugger;
        //debugger;
        //debugger;
        //debugger;
        //alert("Stand down here and figure this out");
    }

    const sagaMiddleware = createSagaMiddleware();
    //console.log( "saga middleware created");

    const oPersistReducer = persistReducer(persistOurConfig, rootReducer);
    //console.log( "persist reducer created");
    const oStore = createStore(
        oPersistReducer,
        oState,
        applyMiddleware(sagaMiddleware)
    );
    //console.log( "store state = " + JSON.stringify( oStore.getState()));
    return {
        ...oStore,
        runSaga: sagaMiddleware.run(rootSaga).toPromise().catch(e => {
            // here we need to redirect to recover from a fatal error
            if (typeof window !== "undefined") {
                //debugger;
                if (window.location.pathname !== "/") {
                    //debugger;
                    window.location.assign("https://" + window.location.host + "/");
                }
                else {
                    window.document.body.outerHTML = "<H1>We are experiencing technical difficulties.</H1><br /><h2>Please retry your request in a few minutes.</h2>";
                }
            }
        })
    };

};

export default configureStore;
